export default __webpack_public_path__ + "static/media/Resume_disable.78de7f15.svg";